export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q02_b.628deb82.png";